<template>

  <el-dialog :show-close="true" :title="dialogTitle" :visible="dialogVisible" @close="bntClick(null)">
    <el-form :model="innerUser">
      <el-form-item label="用户名" :label-width="formLabelWidth">
        <el-input v-model="innerUser.userName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item v-show="dialogShowType!==3" label="用户密码" :label-width="formLabelWidth">
        <el-input v-model="innerUser.passWord" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="用户昵称" :label-width="formLabelWidth">
        <el-input v-model="innerUser.nickName" autocomplete="off"></el-input>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="bntClick(null)">取 消</el-button>
      <el-button type="primary" @click="bntClick(innerUser)">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>

import toastUtils from "@/utils/toastUtils";
import stringUtils from "@/utils/stringUtils";

export default {
  name: "createAppDialog",
  //完整接收props参数
  props: {
    dialogVisible: {
      type: Boolean,
      default: false //默认值
      // required:true //是必要的
    },
    dialogShowType: {
      type: Number,
      default: 1
    },
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    bntClick(value) {
      ///value === null表示取消和关闭按钮
      if (value === null) {
        this.$emit('creatUserClick', value, this.dialogShowType)
        return;
      }
      if (!stringUtils.isValidUsername(value.userName)) {
        toastUtils.warning(this, "用户名格式错误，需要6到12个字符，可以使用英文，数字和下划线，不能全是数字")
        return;
      }

      if (this.dialogShowType !== 3 && !stringUtils.isValidUsername(value.passWord)) {
        toastUtils.warning(this, "密码格式错误，需要6到12个字符，可以使用英文，数字和下划线，不能全是数字")
        return;
      }

      if (!stringUtils.isValidNickName(value.nickName)) {
        toastUtils.warning(this, "昵称格式错误，需要6到12个字符，可以使用中文,英文，数字和下划线，不能全是数字")
        return;
      }

      this.$emit('creatUserClick', value, this.dialogShowType)
    }
  },
  data() {
    return {
      formLabelWidth: '120px',
      innerUser: {}
    }
  },
  computed: {
    dialogTitle() {
      switch (this.dialogShowType) {
        case 1:
          return '新增子账户';
        case 2:
          return '更新子账户';
        case 3:
          return '更新本账户';
        default:
          return '新增子账户';
      }
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue === true) {
        this.innerUser = this.user;
      }
    }
  }

}
</script>

<style scoped>

</style>